import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, isRef as _isRef, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import * as api from '@/api/system/task';
import JsonViewer from 'vue-json-viewer';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Result',
  setup(__props, {
    expose: __expose
  }) {
    const data = ref();
    const dialogVisible = ref(false);
    const open = showData => {
      data.value = showData;
      dialogVisible.value = true;
    };
    const close = () => {
      dialogVisible.value = false;
    };
    const download = data => {
      const param = {
        'fileName': data
      };
      api.downloadFile(param);
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        ref: "dialog",
        title: "详情",
        width: "65%",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        onClose: close
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("关闭")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_unref(JsonViewer), {
          expanded: "",
          value: _unref(data).taskResult
        }, null, 8, ["value"]), _createElementVNode("div", null, [_unref(data).taskResult.files.length > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_1, "附件（下载）")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).taskResult.files, item => {
          return _openBlock(), _createElementBlock("p", {
            key: item
          }, [_createVNode(_component_el_link, {
            type: "primary",
            onClick: $event => download(item)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
            _: 2
          }, 1032, ["onClick"])]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});